import { commonService } from '.';

const getListEEPManager = (body) => {
    return commonService.getWithParam('ListEEPManager/all', body);
};

const getAllYears = () => {
    return commonService.getWithParam('ListEEPManager/allYears', null);
};

export const listEEPManagerService = {
    getListEEPManager,
    getAllYears
}